import React from 'react';
import { Route, Redirect } from 'react-router-dom';


import WrapperTools from '../../components/wrappers/WrapperTools';

function RouteTools({ component: Component, userName, token, expiry, ...rest }) {

  //catch missing required props
  if(!expiry || !token || !userName) {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/tools/login", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //check expiry
  const currentDate = parseInt(new Date().getTime() / 1000);
  const expiryDate = parseInt(expiry);

  //check reducer store and local token values
  const validToken = (token === localStorage.getItem('tools-token'))? true : false;
  const validDate = (currentDate < expiryDate)? true : false;

  return(
        <Route
          {...rest}
          render={props =>
              (userName !== '' && validToken && validDate) ?
                  (<React.Suspense fallback={<WrapperTools inSuspense={true}/>}>
                    <Component {...props} />
                  </React.Suspense>) :
                  (<Redirect to={{ pathname: "/tools/logout", state: {from: props.location} }} /> )
          }
        />
  );
}

export default RouteTools;
